import { render, staticRenderFns } from "./CollapsibleSection.vue?vue&type=template&id=2501078c&scoped=true&"
import script from "./CollapsibleSection.vue?vue&type=script&lang=js&"
export * from "./CollapsibleSection.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleSection.vue?vue&type=style&index=0&id=2501078c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2501078c",
  null
  
)

export default component.exports